export const OFFER_CODE = 'MAPLIO4SAAT';
export const OFFER_DURATION_MS = 4 * 60 * 60 * 1000;
export const OFFER_STORAGE_KEY = 'maplio_offer_expires_at';
export const OFFER_MODAL_SEEN_KEY = 'maplio_offer_modal_seen';
export const OFFER_MODAL_DELAY_MS = 35 * 1000;

function isBrowser() {
  return typeof window !== 'undefined';
}

export function getOrCreateOfferExpiryIso() {
  const fallback = new Date(Date.now() + OFFER_DURATION_MS).toISOString();
  if (!isBrowser()) return fallback;

  const stored = window.localStorage.getItem(OFFER_STORAGE_KEY);
  if (stored) {
    const parsed = Date.parse(stored);
    if (Number.isFinite(parsed) && parsed > Date.now()) {
      return new Date(parsed).toISOString();
    }
  }

  window.localStorage.setItem(OFFER_STORAGE_KEY, fallback);
  return fallback;
}

export function getOfferRemainingMs(offerExpiryIso) {
  const parsed = Date.parse(offerExpiryIso || '');
  if (!Number.isFinite(parsed)) return 0;
  return Math.max(0, parsed - Date.now());
}

export function formatCountdown(remainingMs) {
  const totalSeconds = Math.max(0, Math.floor((remainingMs || 0) / 1000));
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}

export function scrollToApplicationSection() {
  if (!isBrowser()) return;
  const section = document.querySelector('#basvuru');
  if (!section) return;
  section.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
